import type { ReactNode } from 'react';

/** Sections of the workspace side panel, in rail order. */
export type PanelSectionId = 'layers' | 'luminaires' | 'results' | 'surfaces' | 'market' | 'export';

/** Controls a section should flash after the footer sends the user there. */
export type PanelHighlight = 'toggles' | null;

export type GoToSection = (section: PanelSectionId, highlight?: PanelHighlight) => void;

export type StepTone = 'error' | 'warning' | 'info' | 'progress' | 'success' | 'next';

/** One line of the footer's status area. */
export interface StepMessage {
  id: string;
  tone: StepTone;
  text: ReactNode;
  /** Inline link after the text, e.g. "Show" → jumps to the section that fixes it. */
  link?: { label: string; onClick: () => void };
}

/** A footer button. `formId` turns it into a submit button for a form inside the panel. */
export interface StepAction {
  id: string;
  label: string;
  icon?: ReactNode;
  onClick?: () => void;
  formId?: string;
  disabled?: boolean;
  loading?: boolean;
  /** Shown on hover, mostly to say why the action is disabled. */
  tooltip?: string;
  /** Secondary actions with an obvious icon (add) render as a round icon button, so the
   *  primary keeps its full label in a narrow panel. */
  iconOnly?: boolean;
  variant?: 'primary' | 'secondary' | 'danger';
}

export interface NextStep {
  messages: StepMessage[];
  /** Extra controls between the messages and the buttons (e.g. heights to confirm). */
  content?: ReactNode;
  primary?: StepAction;
  secondary?: StepAction;
}

export const MARKET_PREFILTERS_FORM_ID = 'market-match-prefilters';

export const DISTANCE_TO_GROUND_NA = -1;
export const MAX_LAMPS = 50;
export const MIN_LUMINAIRE_HEIGHT_METERS = 2;
export const MAX_LUMINAIRE_HEIGHT_METERS = 25;
